import { TServerMeta } from "./server";

export enum ERequestStatus {
  PROCESSED = "PROCESSED",
  NEW = "NEW",
}

export enum ERequestType {
  NOBO = "NOBO",
  IELTS = "IELTS",
}

export type TRequest = {
  id: number;
  name: string;
  phone: string | null;
  telegram: string | null;
  type: ERequestType;
  status: ERequestStatus;
  createdAt: string | null;
};

export type TRequestResponse = {
  content: TRequest[];
} & TServerMeta;

export type TAddRequestBody = Omit<TRequest, "id" | "status" | "createdAt">;

export type TEditRequestBody = TRequest;
